import React from "react";

const TrackingHeader = ({ trackingData }) => {
  // If no trackingData at all, return null
  if (!trackingData) return null;

  // Get trackingId from orderInformation or from first status
  const trackingId = trackingData.orderInformation?.trackingId || 
                    trackingData.statuses?.[0]?.trackingId || 
                    "Unknown";

  // Get other details from orderInformation if available
  const { documentType, serviceType } = trackingData.orderInformation || {};

  return (
    <div className="tracking-header">
      <div className="tracking-info">
        <h3>Document No: {trackingId}</h3>
        {documentType || serviceType ? (
          <p>Booking Type: {documentType || '-'} {serviceType || '-'}</p>
        ) : null}
      </div>
    </div>
  );
};

export default TrackingHeader;
